export const OPEN_EXTERNAL_LINK = 'link/OPEN EXTERNAL LINK';
export const OPEN_RESTAURANT_LINK = 'link/OPEN RESTAURANT LINK';
export const OPEN_MENU_ENTRY_LINK = 'link/OPEN MENU ENTRY LINK';
